import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "duration", standalone: false })
export class DurationPipe implements PipeTransform {
  transform(milliseconds: number | null): string {
    if (milliseconds === null || milliseconds === undefined) {
      return "--";
    }

    const totalSeconds = Math.floor(milliseconds / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;

    return `${minutes}m ${seconds}s`;
  }
}
